import { Dispatch } from 'redux';
import api from './api'; // Import the configured axios instance

// Action Types
const ADD_NEWSLETTER_REQUEST = 'ADD_NEWSLETTER_REQUEST';
const ADD_NEWSLETTER_SUCCESS = 'ADD_NEWSLETTER_SUCCESS';
const ADD_NEWSLETTER_FAILURE = 'ADD_NEWSLETTER_FAILURE';

// Action Interfaces
interface AddNewsletterRequestAction {
  type: typeof ADD_NEWSLETTER_REQUEST;
}

interface AddNewsletterSuccessAction {
  type: typeof ADD_NEWSLETTER_SUCCESS;
  payload: any; // You can specify a more detailed type based on your API response
}

interface AddNewsletterFailureAction {
  type: typeof ADD_NEWSLETTER_FAILURE;
  payload: string; // Error message
}

type NewsletterActionTypes =
  | AddNewsletterRequestAction
  | AddNewsletterSuccessAction
  | AddNewsletterFailureAction;

// Async Action Creator for adding a new newsletter
export const addNewsletter =
  (email: string, language: string, origin: string) =>
  async (dispatch: Dispatch<NewsletterActionTypes>) => {
    dispatch({ type: ADD_NEWSLETTER_REQUEST });

    try {
      const response = await api.post('/api/newsletter', { email, language, origin });
      dispatch({ type: ADD_NEWSLETTER_SUCCESS, payload: response.data });
    } catch (error: any) {
      dispatch({
        type: ADD_NEWSLETTER_FAILURE,
        payload: error.response?.data?.error || 'Failed to add newsletter',
      });
    }
  };

// Initial State
interface NewsletterState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: NewsletterState = {
  loading: false,
  error: null,
  success: false,
};

// Reducer
const newsletterReducer = (
  state = initialState,
  action: NewsletterActionTypes
): NewsletterState => {
  switch (action.type) {
    case ADD_NEWSLETTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case ADD_NEWSLETTER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case ADD_NEWSLETTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default newsletterReducer;
